var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryPh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_8575)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_8575",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_8575)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V9.33337H12.4444L13.3333 10L0 20Z",
    fill: "#DD1C34"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 9.33333H12.4444L0 0H28V9.33333Z",
    fill: "#0D4BC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99992 3.99996C2.36811 3.99996 2.66659 3.70148 2.66659 3.33329C2.66659 2.9651 2.36811 2.66663 1.99992 2.66663C1.63173 2.66663 1.33325 2.9651 1.33325 3.33329C1.33325 3.70148 1.63173 3.99996 1.99992 3.99996ZM9.99992 10.6666C10.3681 10.6666 10.6666 10.3681 10.6666 9.99996C10.6666 9.63177 10.3681 9.33329 9.99992 9.33329C9.63173 9.33329 9.33325 9.63177 9.33325 9.99996C9.33325 10.3681 9.63173 10.6666 9.99992 10.6666ZM2.66659 16.6666C2.66659 17.0348 2.36811 17.3333 1.99992 17.3333C1.63173 17.3333 1.33325 17.0348 1.33325 16.6666C1.33325 16.2984 1.63173 16 1.99992 16C2.36811 16 2.66659 16.2984 2.66659 16.6666ZM4.53199 11.3266L3.39097 13.0796L3.8237 11.0331C3.75407 10.9763 3.69029 10.9125 3.63342 10.8428L1.58699 11.2756L3.33996 10.1346C3.33552 10.0903 3.33325 10.0454 3.33325 9.99996C3.33325 9.95453 3.33552 9.90963 3.33996 9.86537L1.58699 8.72435L3.63342 9.15708C3.69029 9.08744 3.75407 9.02367 3.8237 8.96679L3.39097 6.92036L4.53199 8.67334C4.57626 8.6689 4.62116 8.66663 4.66659 8.66663C4.71202 8.66663 4.75692 8.6689 4.80118 8.67334L5.9422 6.92036L5.50947 8.96679C5.5791 9.02367 5.64288 9.08744 5.69975 9.15708L7.74618 8.72435L5.99321 9.86537C5.99765 9.90963 5.99992 9.95453 5.99992 9.99996C5.99992 10.0454 5.99765 10.0903 5.99321 10.1346L7.74618 11.2756L5.69976 10.8428C5.64288 10.9125 5.5791 10.9763 5.50947 11.0331L5.9422 13.0796L4.80118 11.3266C4.75692 11.331 4.71202 11.3333 4.66659 11.3333C4.62116 11.3333 4.57626 11.331 4.53199 11.3266Z",
    fill: "#FDD64D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_8575"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryPh);
export default __webpack_public_path__ + "static/media/Country=PH.65f0660a13ecbc1cb8af29d8b608535d.svg";
export { ForwardRef as ReactComponent };